import React from "react";
import AdminLayout from "./AdminLayout";
import AppSettingsManagement from "./AppSettingsManagement";



function AppSettings() {
    return (
        <AdminLayout>
            <AppSettingsManagement />
        </AdminLayout>
    );
}

export default AppSettings;
